module.exports = __webpack_public_path__ + "img/banner.ac2f87ca.jpg";